import React from 'react'
import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'
import { font, greys } from 'assets/themes/theme-default'
import { getCurrency } from 'core/utils/cultures/unit'

import { fundingShape } from '../../../shapes'

const Price = styled.h2`
  font-weight: ${font.weight.base};
  text-align: center;
  color: ${greys.light4};
  span > span {
    font-weight: ${font.weight.bold};
  }
`

const PriceFundingCard = props => {
  const { item } = props

  return (
    <Price data-test="component-configurator-funding-fundingCard-price">
      <FormattedMessage
        id="configurator-funding-card-price"
        values={{
          price: item.price,
          monthly: item.monthly,
          currency: getCurrency()
        }}
      />
    </Price>
  )
}

PriceFundingCard.propTypes = {
  item: fundingShape.isRequired
}

export default PriceFundingCard
